module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1039.0678e8b9.png";